import styled from 'styled-components';

const Container = styled.div`
  margin-top: 3rem;
  align-self: center;

  .container {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    list-style: none;
    flex-wrap: wrap;
    justify-content: center;
  }

  .item {
    border-radius: 999px;
    transition: background-color 0.2s;

    :hover {
      background-color: #f3f3f3;
    }
  }

  .link {
    display: block;
    padding: 0.8rem 1.4rem;
    border-radius: 999px;
    font-size: 1.4rem;
    font-weight: 600;
    color: var(--font-color);
    cursor: pointer;
  }

  .item.active {
    background-color: var(--primary-color);
  }

  .link.active {
    color: #fff;
  }
`;

export default Container;
